const PortfolioDescription = () => {
  return (
    <section className="portfolio-text">
      <h2 className="title-font pink-text h2-tag">My Portfolio</h2>
      <p className="white-text p-tag">
      I have invested substantial time into a diverse range of projects, relishing the opportunity to build everything from scratch.
       Among my favorite projects are those that encapsulate the breadth of my knowledge and skills. 
       In addition, I have embarked on numerous smaller endeavors through various courses and challenges, 
       seeking to grasp the fundamentals. You can explore these projects, which reflect my dedication and growth,
        on my{" "}
        <span>
          <a
            href="https://github.com/tien2612?tab=repositories"
            className="pink-text"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>
        </span>
      </p>
    </section>
  );
};

export default PortfolioDescription;
